/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ReportingPeriod } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ReportingPeriodUpdateForm(props) {
  const {
    id: idProp,
    reportingPeriod: reportingPeriodModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    ReportingPeriodName: "",
    Description: "",
    StartDate: "",
    EndDate: "",
    ReportingPeriodYear: "",
  };
  const [ReportingPeriodName, setReportingPeriodName] = React.useState(
    initialValues.ReportingPeriodName
  );
  const [Description, setDescription] = React.useState(
    initialValues.Description
  );
  const [StartDate, setStartDate] = React.useState(initialValues.StartDate);
  const [EndDate, setEndDate] = React.useState(initialValues.EndDate);
  const [ReportingPeriodYear, setReportingPeriodYear] = React.useState(
    initialValues.ReportingPeriodYear
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = reportingPeriodRecord
      ? { ...initialValues, ...reportingPeriodRecord }
      : initialValues;
    setReportingPeriodName(cleanValues.ReportingPeriodName);
    setDescription(cleanValues.Description);
    setStartDate(cleanValues.StartDate);
    setEndDate(cleanValues.EndDate);
    setReportingPeriodYear(cleanValues.ReportingPeriodYear);
    setErrors({});
  };
  const [reportingPeriodRecord, setReportingPeriodRecord] = React.useState(
    reportingPeriodModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ReportingPeriod, idProp)
        : reportingPeriodModelProp;
      setReportingPeriodRecord(record);
    };
    queryData();
  }, [idProp, reportingPeriodModelProp]);
  React.useEffect(resetStateValues, [reportingPeriodRecord]);
  const validations = {
    ReportingPeriodName: [],
    Description: [],
    StartDate: [],
    EndDate: [],
    ReportingPeriodYear: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          ReportingPeriodName,
          Description,
          StartDate,
          EndDate,
          ReportingPeriodYear,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ReportingPeriod.copyOf(reportingPeriodRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ReportingPeriodUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Reporting Period"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Text
        children="Update this record describing the applicable Disclosure reporting period."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Reporting period name (e.g. 2025 reporting year)"
        isRequired={false}
        isReadOnly={false}
        value={ReportingPeriodName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ReportingPeriodName: value,
              Description,
              StartDate,
              EndDate,
              ReportingPeriodYear,
            };
            const result = onChange(modelFields);
            value = result?.ReportingPeriodName ?? value;
          }
          if (errors.ReportingPeriodName?.hasError) {
            runValidationTasks("ReportingPeriodName", value);
          }
          setReportingPeriodName(value);
        }}
        onBlur={() =>
          runValidationTasks("ReportingPeriodName", ReportingPeriodName)
        }
        errorMessage={errors.ReportingPeriodName?.errorMessage}
        hasError={errors.ReportingPeriodName?.hasError}
        {...getOverrideProps(overrides, "ReportingPeriodName")}
      ></TextField>
      <TextAreaField
        label="Description (e.g. Climate-related disclosure for 2025 year)"
        isRequired={false}
        isReadOnly={false}
        value={Description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ReportingPeriodName,
              Description: value,
              StartDate,
              EndDate,
              ReportingPeriodYear,
            };
            const result = onChange(modelFields);
            value = result?.Description ?? value;
          }
          if (errors.Description?.hasError) {
            runValidationTasks("Description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("Description", Description)}
        errorMessage={errors.Description?.errorMessage}
        hasError={errors.Description?.hasError}
        {...getOverrideProps(overrides, "Description")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid5")}
      >
        <TextField
          label="Start date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={StartDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReportingPeriodName,
                Description,
                StartDate: value,
                EndDate,
                ReportingPeriodYear,
              };
              const result = onChange(modelFields);
              value = result?.StartDate ?? value;
            }
            if (errors.StartDate?.hasError) {
              runValidationTasks("StartDate", value);
            }
            setStartDate(value);
          }}
          onBlur={() => runValidationTasks("StartDate", StartDate)}
          errorMessage={errors.StartDate?.errorMessage}
          hasError={errors.StartDate?.hasError}
          {...getOverrideProps(overrides, "StartDate")}
        ></TextField>
        <TextField
          label="End date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={EndDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ReportingPeriodName,
                Description,
                StartDate,
                EndDate: value,
                ReportingPeriodYear,
              };
              const result = onChange(modelFields);
              value = result?.EndDate ?? value;
            }
            if (errors.EndDate?.hasError) {
              runValidationTasks("EndDate", value);
            }
            setEndDate(value);
          }}
          onBlur={() => runValidationTasks("EndDate", EndDate)}
          errorMessage={errors.EndDate?.errorMessage}
          hasError={errors.EndDate?.hasError}
          {...getOverrideProps(overrides, "EndDate")}
        ></TextField>
      </Grid>
      <TextField
        label="Reporting period year (e.g. 2025)"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={ReportingPeriodYear}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              ReportingPeriodName,
              Description,
              StartDate,
              EndDate,
              ReportingPeriodYear: value,
            };
            const result = onChange(modelFields);
            value = result?.ReportingPeriodYear ?? value;
          }
          if (errors.ReportingPeriodYear?.hasError) {
            runValidationTasks("ReportingPeriodYear", value);
          }
          setReportingPeriodYear(value);
        }}
        onBlur={() =>
          runValidationTasks("ReportingPeriodYear", ReportingPeriodYear)
        }
        errorMessage={errors.ReportingPeriodYear?.errorMessage}
        hasError={errors.ReportingPeriodYear?.hasError}
        {...getOverrideProps(overrides, "ReportingPeriodYear")}
      ></TextField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || reportingPeriodModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || reportingPeriodModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
